import { ColorModeScript } from '@chakra-ui/react';
import React, { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import CQAuditorPortalApp from './CQAuditorPortalApp';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';
import "react-perfect-scrollbar/dist/css/styles.css"

const container = document.getElementById('cq-audit-portal');
const root = ReactDOM.createRoot(container);

root.render(
  <>
    <ColorModeScript />
    <CQAuditorPortalApp />
  </>
);

serviceWorker.unregister();
reportWebVitals();
